//import SearchResult from "../Components/SearchResult/SearchResult";

export const SERVICEURI = {
    Signin : 'EnthAPI/users/login?uid={email}&pwd={password}',
    Search:  'EnthAPI/users/search?key={key}&q={q}&execute=1',
    Results:  'EnthAPI/users/result?key={key}&id={id}'
}